import styled from "styled-components";
import { motion } from "framer-motion";
import {
  EmptyText as SharedEmptyText,
  getToneTokens,
  MetricLabel,
  MetricSub,
  MetricValue,
  MotionMetricCard,
  PageActions,
  PageContainer,
  PageState as SharedPageState,
  PageTitle,
  PageTopBar,
  Section,
  SectionTitle,
  TableWrapper as SharedTableWrapper,
  TabButton,
  Tabs as SharedTabs,
} from "../../styles/shared";

export const Wrapper = styled(PageContainer)``;

export const PageState = styled(SharedPageState)``;

export const TopBar = styled(PageTopBar)``;

export const Titulo = styled(PageTitle)``;

export const TopBarActions = styled(PageActions)``;

export const Secao = styled(Section)``;

export const SecaoTitulo = styled(SectionTitle)``;

export const Abas = styled(SharedTabs)``;

export const Aba = styled(TabButton)``;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 210px), 1fr));
  gap: 12px;
`;

export const CardWrapper = styled(MotionMetricCard)`
  position: relative;
  overflow: visible;
  z-index: ${({ $infoOpen }) => ($infoOpen ? 5 : "auto")};
`;

export const CardLabel = styled(MetricLabel)`
  padding-right: 28px;
`;

export const CardValor = styled(MetricValue)``;

export const CardSub = styled(MetricSub)``;

export const InfoButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 999px;
  border: 1px solid ${({ theme, $active }) => ($active ? theme.accent : theme.border)};
  background: ${({ theme }) => theme.surface};
  color: ${({ theme, $active }) => ($active ? theme.accent : theme.textSecondary)};
  cursor: pointer;
  transition: border-color 0.16s ease, color 0.16s ease, background 0.16s ease;

  &:hover {
    border-color: ${({ theme }) => theme.accent};
    color: ${({ theme }) => theme.accent};
    background: ${({ theme }) => theme.surfaceAlt};
  }
`;

export const KpiPopover = styled.div`
  position: absolute;
  top: 42px;
  right: 10px;
  width: min(320px, calc(100vw - 48px));
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surface};
  box-shadow: 0 18px 42px rgba(15, 15, 20, 0.22);
  display: grid;
  gap: 8px;
`;

export const KpiPopoverTitle = styled.div`
  font-size: 12px;
  font-weight: 800;
  color: ${({ theme }) => theme.textPrimary};
`;

export const KpiPopoverText = styled.p`
  font-size: 12px;
  line-height: 1.45;
  color: ${({ theme }) => theme.textSecondary};
`;

export const KpiPopoverExample = styled(KpiPopoverText)`
  padding-top: 8px;
  border-top: 1px solid ${({ theme }) => theme.border};
  color: ${({ theme }) => theme.textPrimary};
`;

export const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 38px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surface};
  color: ${({ theme }) => theme.textSecondary};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.16s ease, color 0.16s ease, background 0.16s ease;

  &:hover {
    color: ${({ theme }) => theme.accent};
    border-color: ${({ theme }) => theme.accent};
    background: ${({ theme }) => theme.surfaceAlt};
  }
`;

export const DetailTitleBlock = styled.div`
  display: grid;
  gap: 4px;
`;

export const DetailMeta = styled.div`
  color: ${({ theme }) => theme.textSecondary};
  font-size: 13px;
`;

export const CoverageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const CoverageItem = styled.div`
  ${({ theme, $tone = "default" }) => {
    const tokens = getToneTokens(theme, $tone);

    return `
      background: ${tokens.background};
      border: 1px solid ${tokens.border};
    `;
  }}

  border-radius: 12px;
  padding: 14px 16px;
  min-width: 0;
`;

export const CoverageTitle = styled.h3`
  color: ${({ theme, $tone = "default" }) => getToneTokens(theme, $tone).text};
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 8px;
`;

export const KpiList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const KpiPill = styled.span`
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 4px 8px;
  border-radius: 999px;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surface};
  color: ${({ theme }) => theme.textSecondary};
  font-size: 11px;
  font-weight: 600;
  max-width: 100%;
  overflow-wrap: anywhere;
`;

export const TabelaWrapper = styled(SharedTableWrapper)``;

export const Tabela = styled.table`
  width: 100%;
  min-width: ${({ $wide }) => ($wide ? "1120px" : "900px")};
  border-collapse: collapse;
  font-size: 13px;
`;

export const Th = styled.th`
  /* Bugfix #13 (2026-05-29): sticky header amplo. */
  position: sticky;
  top: var(--app-header-height, 0px);
  z-index: 5;
  padding: 11px 14px;
  text-align: ${({ $center, $right }) =>
    $center ? "center" : $right ? "right" : "left"};
  background: ${({ theme }) => theme.surfaceAlt};
  color: ${({ theme }) => theme.textSecondary};
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  border-bottom: 1px solid ${({ theme }) => theme.border};
  white-space: nowrap;
`;

export const Tr = styled(motion.tr).attrs(({ $delay = 0 }) => ({
  initial: { opacity: 0, y: 4 },
  animate: { opacity: 1, y: 0 },
  transition: { delay: $delay, duration: 0.18 },
}))`
  &:hover {
    background: ${({ theme }) => theme.warningSurface};
  }
`;

export const Td = styled.td`
  padding: 10px 14px;
  text-align: ${({ $center, $right }) =>
    $center ? "center" : $right ? "right" : "left"};
  color: ${({ theme, $muted }) => ($muted ? theme.textSecondary : theme.textPrimary)};
  border-bottom: 1px solid ${({ theme }) => theme.border};
  white-space: nowrap;
  vertical-align: middle;
`;

export const LinkButton = styled.button`
  padding: 0;
  border: none;
  background: none;
  color: ${({ theme }) => theme.accent};
  font: inherit;
  font-weight: 700;
  text-align: left;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const Badge = styled.span`
  ${({ theme, $tone = "default" }) => {
    const tokens = getToneTokens(theme, $tone);

    return `
      background: ${tokens.background};
      border: 1px solid ${tokens.border};
      color: ${tokens.text};
    `;
  }}

  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 4px 9px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
`;

export const ScoreCell = styled.div`
  display: grid;
  grid-template-columns: 42px minmax(80px, 1fr);
  align-items: center;
  gap: 8px;
`;

export const ScoreTrack = styled.div`
  height: 8px;
  border-radius: 999px;
  background: ${({ theme }) => theme.surfaceAlt};
  overflow: hidden;
`;

export const ScoreFill = styled.div`
  height: 100%;
  width: ${({ $width = "0%" }) => $width};
  min-width: ${({ $width = "0%" }) => ($width === "0%" ? "0" : "4px")};
  border-radius: 999px;
  background: ${({ theme, $tone = "success" }) => getToneTokens(theme, $tone).text};
`;

export const InlineBarCell = styled.div`
  display: grid;
  grid-template-columns: minmax(90px, 1fr) 46px;
  align-items: center;
  gap: 8px;
`;

export const InlineBar = styled.div`
  height: 8px;
  min-width: 4px;
  width: ${({ $width = "0%" }) => $width};
  border-radius: 999px;
  background: ${({ theme, $tone = "default" }) =>
    $tone === "revenue" ? theme.successText : theme.accent};
`;

export const EmptyText = styled(SharedEmptyText)``;
